import { getUtcDateString } from ".";
import { RecoveryAppFormData, TimeZones } from "../models";

/**
 * @param timeOfDeath Time of Death UTC
 * @param timeOfProcurement Time of Recovery Procedure UTC
 * @returns the number of hours and minutes between time of death and time of procurement.
 */

export const getProcurementTimeUtc = (data: RecoveryAppFormData) => {
    if (!data.ProcedureDate || !data.ProcedureTime || !data.ProcedureTimeZone) return undefined;
    const date = data.ProcedureDate.split("T")[0];
    const time = data.ProcedureTime.split("T")[1];
    return getUtcDateString(`${date}T${time}`, data.ProcedureTimeZone as TimeZones);
};

export const calculateDeathToPreservation = (
    timeOfDeath: string | undefined,
    recoveryFormData: RecoveryAppFormData
) => {
    const timeOfProcurement = getProcurementTimeUtc(recoveryFormData);
    if (!timeOfDeath || !timeOfProcurement) return undefined;

    const tod = new Date(timeOfDeath).getTime();
    const top = new Date(timeOfProcurement).getTime();

    if (tod > top) {
        // TOD should never be greater than TOP
        return { hours: -1, minutes: -1, diffHours: -1 };
    }

    const diffMs = top - tod;
    const diffHours = diffMs / 1000 / 60 / 60;

    const hours = Math.floor(diffHours);
    const minutes = Math.round((diffHours - hours) * 60);

    if (hours === 0 && minutes === 60) {
        return { hours: 1, minutes: 0, diffHours };
    }
    return { hours, minutes, diffHours };
};
